<div title="به اشتراک‌گذاری" class="btn btn-yellow btn-icon-circle mr-2" style="position: fixed;"><i
    class="fa fa-share-alt fs-lg"></i></div>
<iframe frameborder="0" seamless="seamless" scrolling="no" [src]="job?.SourceUrl|bypassSanitizeUrl"></iframe>